
import { computed, defineComponent, ref } from 'vue'
import BellIcon from '../../assets/icons/bell.svg?inline'
import SearchIcon from '../../assets/icons/search.svg?inline'

import useTheme from '@/composables/useTheme'

export default defineComponent({
  name: 'NavThree',
  components: {
    SearchIcon,
    BellIcon,
  },
  setup() {
    const { currentTheme, currentMode } = useTheme()
    const showSearch = ref(false)

    const buttonStyles = computed(() => {
      return [
        currentTheme.value.buttons.primary.bg,
        currentTheme.value.buttons.primary.text,
        currentTheme.value.buttons.primary.hoverBg,
        'transition ease-in-out duration-300',
      ]
    })

    const searchBarClasses = computed(() => {
      const {
        rings,
        input: { bg, placeholder },
      } = currentTheme.value

      return [bg, placeholder, rings.focusPrimary]
    })

    const mobileSearchClasses = computed(() => {
      return showSearch.value ? 'scale-y-100 opacity-100' : 'scale-y-0'
    })

    const toggleSearch = () => {
      showSearch.value = !showSearch.value
    }

    return {
      currentMode,
      currentTheme,
      buttonStyles,
      showSearch,
      mobileSearchClasses,
      searchBarClasses,
      toggleSearch,
    }
  },
})
